interface RoutePermission {
    route: string;
    permission: string;
    priority: number; // Lower number = higher priority
  }
  
  export const routePermissionMap: RoutePermission[] = [
    {
      route: '/admin/dashboard',
      permission: 'Main.Dashboard.View',
      priority: 1,
    },
    {
      route: '/admin/members',
      permission: 'Member.Members.View',
      priority: 2,
    },
    {
      route: '/admin/bulkemails',
      permission: 'Communication.BulkEmails.View',
      priority: 3,
    },
    {
      route: '/admin/users',
      permission: 'Settings.Administrators.View',
      priority: 4,
    },
    {
      route: '/admin/auditlogs',
      permission: 'Settings.AuditLog.View',
      priority: 5,
    },
    {
      route: '/admin/companyinfo',
      permission: 'Settings.CompanyInfo.View',
      priority: 6,
    },
  ];
  
  export const getFirstAvailableRoute = (userPermissions: string[]): string => {
    const availableRoute = routePermissionMap
      .sort((a, b) => a.priority - b.priority) // Sort by priority
      .find(route => userPermissions.includes(route.permission));
  
    return availableRoute?.route || '/login'; // Fallback to login if no permissions match
  };